{ doAction, fetchJson } = require './index'
extend = require 'extend'

LOG_OUT = 'LOG_OUT'
LOGGED_IN = 'LOGGED_IN'
LOGGING_IN = 'LOGGING_IN'
CHECKING_TOKEN = 'CHECKING_TOKEN'
CHECKED_TOKEN = 'CHECKED_TOKEN'

module.exports = {
	CHECKING_TOKEN
	CHECKED_TOKEN
	LOG_OUT
	LOGGING_IN
	LOGGED_IN

	checkToken: ->
		# Check the user's JWT.  The endpoint will return a 401 if the JWT is invalid, or will
		# return a refreshed JWT if the original hasn't expired yet.  The `doAction` method will
		# automatically refresh the token in the redux state if provided by the API.
		fetchUrl = '/api/auth/check'
		method = 'get'
		payload = null
		doingActionType = CHECKING_TOKEN
		didActionType = CHECKED_TOKEN
		failureMessage = null
		successMessage = null
		getSuccessPayload = (responseJson) -> null
		doAction(fetchUrl, method, payload, doingActionType, didActionType, failureMessage, successMessage, getSuccessPayload)

	login: (credentials) ->
		(dispatch) ->
			dispatch
				type: LOGGING_IN
			token = null
			invalidCredentialsMessage = "The credentials you supplied are invalid. Please check them and try again."
			###
			The Knock gem in Rails only returns the JWT and doesn't let us override that, so we have a secondary, secure, route that provides extra information. Fetching that extra info could fail, in which case we'd have the token but not the user info, which would be weird for display purposes ("Hello, [blank]!"), so I've set this up in sort of a transactional way here, such that both the login and fetch of user info must succeed.
			###
			fetchJson '/user_token',
				method: 'post'
				body:
					auth:
						credentials
				includeToken: false
			, { includeToken: false }
			.then (responseJson) ->
				if !responseJson.jwt
					throw new Error(invalidCredentialsMessage)
				else
					token = responseJson.jwt
					payload = responseJson
					if payload?.success
						auth = extend true, { token }, payload
						delete auth.success
						localStorage.setItem 'auth', JSON.stringify(auth)
						dispatch
							type: LOGGED_IN
							payload: auth
					else
						dispatch
							type: LOGGED_IN
							error: true
							payload:
								message: "Invalid response from server during log in"
				payload
			.catch (error) ->
				if error?.response?.status == 403
					# 403 errors are returned by the token controller when the user needs to change their password for
					# some reason.  These responses will carry a `destination` that can be used for redirection
					error?.response?.json().then (parsedJson) =>
						if parsedJson.destination
							window.location.href = parsedJson.destination
				else if error?.response?.status >= 400
					dispatch
						type: LOGGED_IN
						error: true
						payload:
							message: invalidCredentialsMessage
				else
					dispatch
						type: LOGGED_IN
						error: true
						payload: { error }

	logout: ->
		(dispatch) ->
			fetch('/auth/logout').then (response) =>
				dispatch
					type: LOG_OUT
				localStorage.removeItem 'auth'

	redirectAfterLogin: (router, redirectPath) ->
		router.push redirectPath ? '/'
}



// WEBPACK FOOTER //
// ./frontend/olos/js/actions/auth.coffee